module.exports = __webpack_public_path__ + "static/media/bling.e0f8fef3.svg";